import styled, { css } from 'styled-components';

const beforeTodayStyle = css`
  color: ${({ theme }) => theme.kallisto.color.common.black[200]};
  cursor: default;

  &::before {
    content: unset;
    border: 0;
    height: unset;
    position: absolute;
  }

  &:hover {
    //background: transparent;
    &::before {
      content: unset;
      border: 0;
      height: unset;
      position: absolute;
      @media only screen and (min-width: 768px) {
        box-shadow: unset;
      }
    }
  }
`;
const activeColors = css`
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected};
`;

const activeStart = css`
  ${activeColors};
  border-radius: 26px 0 0 26px;
`;

const activeEnd = css`
  ${activeColors};
  border-radius: 0 26px 26px 0;
`;

const activeEndContinueRight = css`
  ${activeColors};
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected},
    white
  );

  &:hover {
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected},
      white
    );
  }
`;

const disabledEndContinueRight = css`
  ${activeColors};
  background: linear-gradient(to right, ${({ theme }) => theme.kallisto.color.common.black[50]}, white);

  &:hover {
    background: linear-gradient(to right, ${({ theme }) => theme.kallisto.color.common.black[50]}, white);
  }
`;

const activeEndContinueLeft = css`
  ${activeColors};
  background: linear-gradient(
    to right,
    white,
    ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected}
  );

  &:hover {
    background: linear-gradient(
      to right,
      white,
      ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected}
    );
  }
`;

const disabledEndContinueLeft = css`
  ${activeColors};
  background: linear-gradient(to right, white, ${({ theme }) => theme.kallisto.color.common.black[50]});

  &:hover {
    background: linear-gradient(to right, white, ${({ theme }) => theme.kallisto.color.common.black[50]});
  }
`;
const active = css`
  ${activeColors};
  z-index: 1;
`;

export const DayStyled = styled.div`
  margin-bottom: 3px;
  position: relative;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-style: normal;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  max-width: calc(100% / 7);
  border-radius: 4px;
  outline: none;

  &:hover {
    z-index: 2;
    &::before {
      border-radius: 20px;
      content: '';
      position: absolute;
      left: 2px;
      top: 2px;
      width: 40px;
      height: 40px;
      @media only screen and (min-width: 768px) {
        box-shadow: 0 0 0 1px ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      }
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    outline-offset: 2px;
    z-index: 2;
  }
  &.day-active,
  &.day-highlight-active,
  &.day-active-start,
  &.day-highlight-active-start,
  &.day-active-end,
  &.day-highlight-active-end {
    ${activeColors};
  }

  &.day-active-start,
  &.day-highlight-active.day-highlight-active-start {
    ${activeStart};
  }

  &.day-active,
  &.day-highlight-active {
    ${active};
  }

  &.day-active-end,
  &.day-highlight-active.day-highlight-active-end {
    ${activeEnd};
  }

  &.day-highlight-active:not(.day-highlight-active-start):not(.day-highlight-active-end),
  &.day-active.day-active-start.day-highlight-active.day-highlight-active-end {
    border-radius: 0;
  }

  &.day-active-exact {
    ${active};
    border-radius: 26px;
  }
  &.day-disabled,
  &.day-empty {
    ${beforeTodayStyle};
  }

  &.day-active.day-disabled {
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }

  //  MULTIPLE MONTHS SELECTION
  // when in the calendar you select a range of dates that span multiple months
  // we add a gradient to show the selection continues to the next month
  // SELECTOR EXPLANATION: select .day-empty that is followed by .day-active-start but not .day-active-end
  &.day-active + .day-empty:not(.day-active-end + .day-empty),
  
  // SELECTOR EXPLANATION: as above but for hover effect when selecting dates
  &.day-highlight-active + .day-empty:not(.day-highlight-active-end + .day-empty) {
    ${activeEndContinueRight};

    .day-disabled + & {
      ${disabledEndContinueRight};
    }
  }

  // MULTIPLE MONTHS SELECTION
  // when in the calendar you select a range of dates that span multiple months
  // we add a gradient to show the selection continues from the previous month
  // SELECTOR EXPLANATION: select .day-empty that is followed by .day-active but not .day-active-start
  &.day-empty:has(+ .day-active):not(:has(+ .day-active-start)),
  
  // SELECTOR EXPLANATION: as above but for hover effect when selecting dates
  &.day-empty:has(+ .day-highlight-active):not(:has(+ .day-highlight-active-start)) {
    ${activeEndContinueLeft};

    &:has(+ .day-disabled) {
      ${disabledEndContinueLeft};
    }
  }
`;
